import { Dispatch, SetStateAction, useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { CalendarValue } from './types';
import { monthString } from './utils';
import DateTimeInput from './DateTimeInput';

const today = new Date();
today.setHours(0, 0, 0, 0); // 시간 초기화

interface Props {
  rawValue: CalendarValue;
  setRawValue: Dispatch<SetStateAction<CalendarValue>>;
  startDateValue: string;
  endDateValue: string;
  startTimeValue: string;
  endTimeValue: string;
  setStartTimeValue: Dispatch<SetStateAction<string>>;
  setEndTimeValue: Dispatch<SetStateAction<string>>;
  minDate?: Date;
}

const CustomRangeCalendar = ({
  rawValue,
  setRawValue,
  startDateValue,
  endDateValue,
  startTimeValue,
  endTimeValue,
  setStartTimeValue,
  setEndTimeValue,
  minDate
}: Props) => {
  const [showDoubleView, setShowDoubleView] = useState(window.innerWidth >= 870);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 870 !== showDoubleView) {
        setShowDoubleView(window.innerWidth >= 870);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [showDoubleView]);

  return (
    <div className="flex flex-col gap-3 bg-bg-layer3">
      <div className="p-2 sm:p-4">
        <Calendar
          showDoubleView={showDoubleView}
          showFixedNumberOfWeeks
          className="iops-calendar w-full max-w-full"
          selectRange
          locale="en"
          value={rawValue}
          minDate={minDate}
          defaultValue={[today, today]}
          onChange={(value) => {
            if (!value) return; // null 값 방지
            setRawValue(value); // 선택한 날짜 그대로 저장
          }}
          navigationLabel={({ date }) =>
            `${monthString[date.getMonth()]} ${date.getFullYear()}`
          }
          formatDay={(_, date) => `${date.getDate()}`}
          formatShortWeekday={(_, date) => date.toLocaleDateString('en', { weekday: 'short' })}
          tileClassName={({ date, view }) => {
            if (view === 'month') {
              if (date.toDateString() === today.toDateString()) {
                return 'react-calendar__tile--today';
              }
              if (date.getDay() === 0 || date.getDay() === 6) {
                return 'weekend-tile';
              }
            }
            return null;
          }}
        />
      </div>
      <div className="mb-3 flex flex-col gap-4 p-2 sm:p-4 md:flex-row lg:flex-row lg:gap-6 md-custom">
        <DateTimeInput
          dateLabel="Start Date"
          timeLabel="Start Time"
          dateValue={startDateValue}
          timeValue={startTimeValue}
          setTimeValue={setStartTimeValue}
        />
        <DateTimeInput
          dateLabel="End Date"
          timeLabel="End Time"
          dateValue={endDateValue}
          timeValue={endTimeValue}
          setTimeValue={setEndTimeValue}
        />
      </div>
    </div>
  );
};

export default CustomRangeCalendar;
